import { createComparingLifecycle } from "./lifecycle";
export function shouldUpdate(callback) {
    return createComparingLifecycle("shouldComponentUpdateCallback", callback);
}
export default shouldUpdate;

//# sourceMappingURL=shouldUpdate.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/shouldUpdate.js
// module id = 9
// module chunks = 0